(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */
// import $ from 'jquery';
window.$ = jQuery; // import LazyAds from './modules/sample-module.js';

$(document).ready(function () {
  'keydown mouseover touchmove touchstart wheel'.split(" ").forEach(function (e) {
    window.addEventListener(e, detectUserInteraction, false);
  });

  function detectUserInteraction() {
    'keydown mouseover touchmove touchstart wheel'.split(" ").forEach(function (e) {
      window.removeEventListener(e, detectUserInteraction, false);
    });
    var script = document.createElement('script');
    script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';
    script.setAttribute("data-ad-client", "ca-pub-7392765685388813");
    var scripts = '<script data-ad-client="ca-pub-7392765685388813" async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>';
    document.getElementsByTagName('head')[0].appendChild(script);
  }
});

},{}]},{},[1]);
